import { getUser } from "@braze/web-sdk";
import { logger } from "@origin-digital/reporting-client";
import { IBrazeInit, NewBrazeUser } from "../consts/interfaces";
import { getNewBrazeUser } from "./user";

export const loadBrazeSdkUserId = (): Promise<string | undefined> =>
  new Promise((resolve) => {
    getUser()?.getUserId((userId: string | null) => {
      if (userId == null) {
        logger.warn("[braze] initialized - getUser() returned null userId");
      }
      return resolve(userId ?? undefined);
    });
    resolve(undefined); // if getUser == null
  });

export const findOrCreateNewBrazeUser = async (
  brazeObj: IBrazeInit
): Promise<NewBrazeUser> => {
  if (brazeObj.hasSdkInit) {
    const bzid = await loadBrazeSdkUserId();
    if (bzid) return { bzid, created: false };
  }
  return await getNewBrazeUser();
};
